import { http } from "../../../../config/HttpCommon";

export const GetControllerDetails = async (userId: string, nodeId: string, controllerType: string) => {
    const response = await http.get(`/getControllerDetails/${userId}/${encodeURIComponent(nodeId)}/${controllerType}`);
    return response.data;
};


export enum looupKeys {
    webSocketTimeOut = 'WS_GET_CURRENT_SETPOINT_TIMEOUT',
    sleAggregationRange = 'SLE_AGGREGATION_RANGE',
    xspocAggregationRnge = 'XSPOC_AGGREGATION_RANGE'
}


